import { render } from "./AddFromCatalog.vue?vue&type=template&id=689155f9&scoped=true"
import script from "./AddFromCatalog.vue?vue&type=script&lang=js"
export * from "./AddFromCatalog.vue?vue&type=script&lang=js"

import "./AddFromCatalog.vue?vue&type=style&index=0&id=689155f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689155f9"]])

export default __exports__